import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({ userAuthInfo, rolesAccept, component: Component, ...rest }) => {
    if (userAuthInfo.loading) {
        return null
    }

    const checkIsCorrect = () => {
        const { isSign, role, permissions } = userAuthInfo
        if (!isSign) return false
        // Comprobación estándar por rol
        if (rolesAccept.includes(role)) return true
        // Usuarios con permissions pueden acceder a rutas de nivel admin
        if (permissions && rolesAccept.includes('admin')) return true
        return false
    }

    return (
        <Route {...rest} render={props => (
            checkIsCorrect()
                ? <Component {...props} {...rest} />
                : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )} />
    )
}

function mapStateToProps(state) {
    return { userAuthInfo: state.user };
}

export default connect(mapStateToProps)(PrivateRoute);
